import {
  Project,
  Identifiable,
  StrategicAxis,
  ProjectStrategicAxis,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveProjectStrategicAxis(httpClient: HttpClient) {
  return (
    project: Identifiable<Project>,
    strategicAxis: Identifiable<StrategicAxis>,
    projectStrategicAxis: ProjectStrategicAxis,
  ) =>
    new Promise<Identifiable<ProjectStrategicAxis>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<ProjectStrategicAxis>>({
          endpoint: "/projectStrategicAxeses",
          method: HttpMethods.POST,
          data: {
            project: `projects/${project.uuid}`,
            strategicAxes: `strategicAxes/${strategicAxis.uuid}`,
            ...projectStrategicAxis,
          },
        })
        .then((projectStrategicAxis) => ({
          ...projectStrategicAxis,
          strategicAxisId: strategicAxis.uuid,
          weight: strategicAxis.weight,
        }))
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { saveProjectStrategicAxis };
